// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { css } from 'styled-components';
import { snjGradientBackgroundPosition, snjGradientBackgroundSize } from '@tcp/core/styles/utils';
import { getBrand, getImageFilePath, getIconPath } from '@tcp/core/src/utils';
import { THANKYOU_ICON_FILL_COLOUR } from '@tcp/core/src/constants/brandSpecific.constants';

const getOverrideColorStyle = (props, defaultColor) => {
  return !isEmpty(props.brandThemeColor) ? props.brandThemeColor.color : defaultColor;
};

export default css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: ${(props) => props.theme.colorPalette.white};
  z-index: ${(props) => props.theme.zindex.zDrawer};

  @keyframes slide-out-nav {
    0% {
      opacity: 1;
      display: block;
      transform: scaleY(1);
    }
    99% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0);
      display: none;
      opacity: 0;
    }
  }
  .L2-panel-container {
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-right: 50px;
    }
  }

  .shop-by-size-links {
    padding: 10px 14px 10px;
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      @media ${(props) => props.theme.mediaQuery.large} {
        flex-wrap: unset;
        justify-content: space-between;
      }
    }
  }
  .shop-by-size-links li {
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[800]};
    width: 40px;
    height: 40px;
    border-radius: 20px 20px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-bottom: 16px;
    margin-right: 18px;
    &:nth-child(n + 5) {
      margin-right: 0;
    }
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 38px;
      height: 38px;
    }
  }
  .shop-by-size-links li:hover {
    border: solid 1px ${(props) => props.theme.brandSpecificStyles.BACK_TO_TOP_BORDER_COLOR};
    background-color: ${(props) => props.theme.brandSpecificStyles.BACKGROUND_HOVER_L2};
  }
  .l2-image-banner {
    display: none;
  }
  .l2-promo-box {
    display: none;
  }
  .l2-image-banner-link {
    .icon-arrow {
      display: none;
    }
  }
  .icon-back {
    position: absolute;
    top: 17px;
    left: 0;
    background: url(${(props) => getImageFilePath(props)}/carrot-medium-left-gray.svg);
    width: 10px;
    height: 18px;
    transform: unset;

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 38px;
      height: 38px;
      background-repeat: no-repeat;
    }
  }
  .l1-label {
    padding: 18px 0;
  }
  .sizes-range-background {
    min-height: 40px;
    text-align: center;
    position: relative;
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    margin: 0 14px;
  }

  .l2-nav-link {
    display: flex;
    align-items: center;
    padding: 18px 14px 17px 28px;
    line-height: 1.15;
    &.highlighted {
      color: ${(props) => props.theme.colorPalette.secondary.main};
    }
  }

  .l2-nav-category-heading {
    margin: 0;
    padding: 18px 14px 17px 14px;
    background-color: ${(props) => props.theme.brandSpecificStyles.NAV_CATEGORY_HEADING};
  }

  .s-display-none {
    display: none;
  }

  .dark-overlay {
    display: none;
    background-color: ${(props) => props.theme.colorPalette.gray[900]};
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    height: 100vh;
    opacity: 0.6;
    width: 100%;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .l2-nav-category {
      margin: 0;
    }
    .content-wrapper {
      margin: 0;
      width: 100%;
    }
    .nav-bar-l2-details {
      outline: none;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .l2-nav-category {
      margin: 0;
    }

    .content-wrapper {
      margin: 0;
      width: 100%;
    }
    .nav-bar-l2-details {
      outline: none;
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .l2-nav-category:last-child .l2-nav-category-links,
    .nav-bar-l2-details,
    .l2-nav-category.hide-border .l2-nav-category-links {
      ${(props) =>
        props.shouldRenderMobileNavRedesignedView ? 'border-bottom: none !important;' : ''}
    }

    &.nav-bar-l2-panel.nav-bar-l2-mobile-redesign {
      .sizes-range-background {
        display: flex;
        margin: 0;
        padding: 17px 16px;
        align-items: center;
        column-gap: 10px;
        min-height: unset;
        background: #f3f3f3;
        border-bottom: none;
      }

      .l1-label {
        padding: 0;
        color: #000;
        font-family: Nunito;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        text-transform: capitalize;
      }

      .icon-back {
        background: url(${(props) => getIconPath('chevron-right', props)}) no-repeat;
        background-size: 24px 24px;
        transform: rotate(180deg);
        position: unset;
        width: 24px;
        height: 24px;
      }

      .l2-nav-category-header {
        padding: 24px 16px 0px 16px;
        display: flex;
        align-items: center;
      }

      .l2-nav-category-heading {
        padding: 0;
      }

      .l2-nav-category-header,
      .l2-nav-category-heading {
        color: #000;
        font-family: Nunito;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        letter-spacing: 0.16px;
        text-transform: capitalize;
        background: transparent;
      }

      .l2-nav-category-links,
      .nav-bar-l2-details:has(.group-link) {
        padding: 24px 16px 24px 32px;
        border-bottom: 1px solid #e3e3e3;

        /* stylelint-disable max-nesting-depth */
        &,
        ul {
          display: flex;
          flex-direction: column;
          row-gap: 20px;
        }
      }

      .l2-nav-link {
        padding: 0;
        display: flex;
        align-items: center;
        column-gap: 16px;
      }

      .nav-bar-item-label-mobile-redesign {
        color: #000;
        font-family: Nunito;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        text-transform: capitalize;
        width: 50%;
        min-width: 50%;
      }

      .nav-bar-item-label-mobile-redesign.highlighted {
        color: #c8102e;
      }

      .nav-bar-item-label-mobile-redesign.full-width {
        width: auto;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.isShowNavAnimation && props.navL1ItemLength
        ? 'animation: slide-out-nav 250ms 400ms forwards;'
        : 'display: none;'}
    ${(props) => (props.isShowNavAnimation && !props.navL1ItemLength ? 'opacity:0;' : '')}
    top: 100%;
    z-index: 100;
    border-top: 1px solid;
    border-color: ${(props) =>
      getOverrideColorStyle(props, THANKYOU_ICON_FILL_COLOUR[getBrand()?.toUpperCase()])};
    ${(props) => (props.isNewNavigationImagesEnabled ? 'border-color: transparent;' : '')};
    .s-display-none {
      display: block;
    }
    .icon-back,
    .l1-label,
    .nav-bar-item-sizes-range {
      display: none;
    }
    .l2-nav-category {
      box-sizing: border-box;
      border-right: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
      margin-top: 36px;
      margin-bottom: 36px;
    }
    .l2-nav-category.shop-by-size-category {
      border-right: 0;
    }
    .l2-nav-category.no-border {
      border-right: 0;
    }
    .l2-nav-category-header {
      margin-bottom: 0;
    }
    .l2-nav-category-empty-header {
      margin-bottom: 61px;
    }
    .l2-nav-category-heading {
      ${(props) =>
        props.isNewNavigationImagesEnabled && `font-weight: ${props.theme.fonts.fontWeight.bold};`}
      padding: 0 0 15px 0;
      background: none;
    }
    .l2-nav-category-divider {
      ${(props) =>
        props.isNewNavigationImagesEnabled ? 'display: none;' : 'display: inline-block;'}
      position: absolute;
      width: 88px;
      height: 1px;
      border-radius: 0.5px;
      background-color: ${(props) =>
        getOverrideColorStyle(props, props.theme.colorPalette.primary.main)};
    }
    .l2-nav-category-links {
      display: flex;
      ul {
        width: 100%;
        flex-grow: 1;
      }
      ul.half-width {
        width: 50%;
      }

      .nav-bar-item-label {
        border-bottom: 2px solid ${(props) => props.theme.colorPalette.white};
        padding-bottom: 4px;
        display: inline-block;
        width: auto;
      }
      .nav-bar-item-label:hover {
        width: auto;
        border-color: ${(props) =>
          getOverrideColorStyle(props, props.theme.brandSpecificStyles.L2_HOVER)};
      }
    }
    .l2-nav-link {
      display: block;
      padding: 11px 0 5px 0;
      line-height: 1.11;
      &.l2-nav-split-nav-link {
        padding: 13px 0 22px 0;
      }
      &.promo-box-link {
        padding: 12px 0 15px 0;
      }
    }
    .shop-by-size-links {
      display: flex;
      padding: 0;
      ul {
        display: block;
      }
      li {
        margin-right: 30px;
      }
    }
    .l2-image-banner {
      display: block;
      margin-top: 36px;
      margin-bottom: 36px;
    }
    .l2-image-banner-link {
      .nav-bar-l1-item-label {
        width: auto;
      }
      .icon-arrow {
        display: inline-block;
        margin-left: 10px;
        width: 10px;
      }
      span {
        display: inline-block;
      }
    }
    .l2-promo-box-wrapper {
      display: block;
      margin-top: 36px;
      margin-bottom: 36px;
    }
    .l2-promo-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      max-width: 210px;
      box-sizing: border-box;
      height: 220px;
      padding: 0 5.5%;
      text-align: left;
      border-style: solid;
      border-width: 3px;
      &.l2-half-promo-box {
        padding: 0 6%;
        height: 89px;
      }
      &.border-pink {
        border-color: #ff3db4;
      }
      &.border-purple {
        border-color: #b976cc;
      }
      &.border-orange {
        border-color: #ff6b00;
      }
      &.border-blue {
        border-color: #49a6e0;
      }
      &.border-yellow {
        border-color: #f6d343;
      }
      &.border-red {
        border-color: #ed0505;
      }
    }
    .sizes-range-background {
      background: ${(props) => props.theme.brandSpecificStyles.L2_BG_COLOR};
      width: 100%;
      border-bottom: none;
      margin: 0;
    }
    .sizes-range-background-snj {
      background-size: ${(props) => snjGradientBackgroundSize(175, 25, props.visibleItemCount)};
      background-position: ${(props) =>
        snjGradientBackgroundPosition(props.visibleItemCount, props.l1Index)};
    }
  }
`;
